import React from 'react';

export default function Footer() {
  return (
    <div className="bg-black">
      <div className="container mx-auto px-8 flex flex-col sm:pt-16 pt-11 font-[Rubik] pb-16">
        <div className="sm:flex sm:flex-row sm:justify-between sm:items-center sm:text-left text-center text-white">
          <div className="sm:w-[37%] sm:mx-0 mx-[15%]">
            <p className="text-primary sm:text-2xl text-xl font-medium">
              Mau jadi kontributor di <span className="font-normal">visit</span>Tegal?
            </p>
            <p className="text-[#999999] sm:text-sm text-xs sm:mt-0 mt-4">
              Dengan menjadi kontributor, Anda bisa mendaftarkan tempat wisata, event, festival,
              kafe ataupun usaha milik Anda secara gratis.
            </p>
          </div>
          <button className="bg-primary sm:px-11 sm:py-4 px-6 py-2 rounded sm:text-lg text-sm text-center font-medium sm:mt-0 mt-10">
            Jadi Kontributor
          </button>
        </div>

        <hr className="border-footer sm:my-14 my-10" />

        <div className="sm:grid sm:grid-cols-3 justify-items-end text-white sm:static relative">
          <div className="mx-4">
            <p className="text-primary sm:text-3xl text-xl font-normal">
              visit<span className="font-medium">Tegal</span>
            </p>
            <p className="text-[#999999] sm:text-sm text-xs my-3">
              Website ini dibuat untuk lebih mengenalkan keberagaman Kota/Kabupaten Tegal kepada
              masyarakat luas. Oleh karena itu dukungan dari masyarakat daerah Tegal akan sangat
              membantu. Oleh karen itu kami sangat terbuka untuk berkerjasama.
            </p>
            <p className="text-[#999999] text-xs sm:static absolute bottom-[-6%] sm:mx-0 mx-[25%] mt-3">
              Copyright @2020 All rights reserved
            </p>
          </div>
          <div className="mx-4">
            <p className="text-primary sm:text-3xl text-xl sm:mt-0 mt-8">Menu</p>
            <ul className="text-[#999999] sm:text-sm text-xs my-3">
              <li className="my-3">Promosikan bisnis/usaha</li>
              <li className="my-3">Menjadi kontributor</li>
              <li className="my-3">Kerjasama</li>
              <li className="my-3">Belajar buat website & aplikasi</li>
              <li className="my-3">Developer/Owner</li>
            </ul>
          </div>
          <div className="mx-4">
            <p className="text-primary sm:text-3xl text-xl sm:mt-0 mt-8">Kontak Kami</p>
            <ul className="text-[#999999] sm:text-sm text-xs my-3">
              <li className="flex items-center my-3">
                <img src="/assets/images/email.svg" alt="email" className="mr-5" />
                <a href="#">visittegal@gmail.com</a>
              </li>
              <li className="flex items-center my-3">
                <img src="/assets/images/phone.svg" alt="phone" className="mr-5" />
                <a href="#">0856-4044-0802</a>
              </li>
              <li className="flex items-center my-3">
                <img src="/assets/images/instagram.svg" alt="instagram" className="mr-5" />
                <a href="#">@visittegal</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
